/* eslint-disable react/forbid-prop-types */
import React, { useEffect, useContext } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { hot } from 'react-hot-loader';
import { TrackingContext } from '@vrbo/react-event-tracking';
import { FlagIcon } from '@ferris/react';
import TranslationUtil from '../../../utils/TranslationUtil';
import withPageFlow from '../../PageFlow/PageFlow';
import { getAdditionalLocales } from '../../../utils/LocaleMap';
import { findByLocale } from './localeMappings';
import { createInteractionEvent, createPageViewEvent } from '../../../utils/EventProviders/EgClickstreamUtil';

export const LanguageSelection = (props) => {
    const {
        analytics,
        referrer,
        translations,
        siteId,
        tpid,
        eapid,
        langId,
        utmSource,
        mainTitle,
        subTitle,
        canonicalLocale
    } = props;

    const { trigger } = useContext(TrackingContext);

    useEffect(() => {
        trigger('pageLoad', { pageName: 'partner-qualifier: languageSelection', referrer });
        trigger('pageview', createPageViewEvent('language_selection'));
        analytics.setAnalyticsPageName('LanguageSelectionStep');
        analytics.viewTTIstop();
        trigger('pageLoadGtm', { pageName: 'LanguageSelectionStep', event: 'LanguageSelectionStepLoad' });

        return () => {
            trigger('pageUnload', { referrer });
            analytics.viewTTIstart();
        };
    }, []);

    const handleCountryChange = (locale) => {
        const vrboLocale = locale;
        const destinationUrl = `/${vrboLocale}/list/property-details?theme=mvp&utm_medium=referral&utm_source=ULX_MVP`;
        const interactionEventName = 'language_button.selected';
        trigger('interaction', createInteractionEvent(interactionEventName, 'LanguageSelection', 'LanguageSelection', vrboLocale.split('-').join('_')));
        window.location.href = destinationUrl;
    };

    const renderDiv = () => {
        // eslint-disable-next-line max-len
        const localeArr = getAdditionalLocales(siteId, tpid, eapid, langId, utmSource, canonicalLocale);
        const langItems = localeArr.map((loc) => {
            const localeMapping = findByLocale(loc);
            const { language } = localeMapping;
            return (
                <div className="languageSelection__item" key={localeMapping.locale}>
                    <div className="languageSelection__itemUpper">
                        <FlagIcon
                            name={localeMapping.flag}
                            size="large"
                            type="standard"
                        />
                        <div className="languageSelection__VrboCountry">{localeMapping.vrboCountry}</div>
                    </div>
                    <button type="button" className="languageSelection__itemLower" onClick={() => { handleCountryChange(localeMapping.locale); }}>{translations.getTranslation('languageSelection_continueButton', { language })}</button>
                </div>
            );
        });

        const separator = <div className="languageSelection__separator" />;

        const gridItems = [];
        langItems.forEach((item, index) => {
            gridItems.push(item);
            if (index % 2 === 0 && langItems.length > 1) {
                gridItems.push(separator);
            }
        });

        return (
            <div className={`languageSelection__wrapperDiv ${localeArr.length > 1 ? 'multiple' : ''}`}>
                {gridItems}
            </div>
        );
    };

    return (
        <div className="languageSelection__mainWrapper">
            <p className="languageSelection__title">{mainTitle}</p>
            <p className="languageSelection__title2">{subTitle}</p>
            {renderDiv()}
        </div>

    );
};

LanguageSelection.propTypes = {
    referrer: PropTypes.string.isRequired,
    history: PropTypes.shape({
        push: PropTypes.func.isRequired
    }).isRequired,
    pageFlow: PropTypes.shape({
        next: PropTypes.func.isRequired
    }).isRequired,
    mainTitle: PropTypes.string.isRequired,
    subTitle: PropTypes.string.isRequired,
    analytics: PropTypes.shape({
        viewTTIstart: PropTypes.func,
        viewTTIstop: PropTypes.func,
        setAnalyticsPageName: PropTypes.func
    }).isRequired,
    // eslint-disable-next-line react/forbid-prop-types, react/require-default-props
    translations: PropTypes.object,
    siteId: PropTypes.string.isRequired,
    tpid: PropTypes.string.isRequired,
    eapid: PropTypes.string.isRequired,
    langId: PropTypes.string.isRequired,
    utmSource: PropTypes.string.isRequired,
    canonicalLocale: PropTypes.string.isRequired
};


/* istanbul ignore next */
const mapDispatchToProps = () => ({
});


/* istanbul ignore next */
const mapStateToProps = (state) => {
    const {
        app
    } = state;
    const {
        referrer, query, locale
    } = app;

    const {
        // eslint-disable-next-line camelcase
        siteId, tpid, eapid, langId, utm_source
    } = query;

    const translations = new TranslationUtil(app.translations, app.fallbackTranslations);

    return {
        mainTitle: translations.getTranslation('languageSelection_mainTitle'),
        subTitle: translations.getTranslation('languageSelection_subTitle'),
        referrer,
        translations,
        siteId,
        tpid,
        eapid,
        langId,
        utmSource: utm_source,
        canonicalLocale: locale.canonical
    };
};

const LanguageSelectionInfo = connect(mapStateToProps, mapDispatchToProps)(LanguageSelection);
LanguageSelectionInfo.displayName = 'LanguageSelectionStep';
export default hot(module)(withPageFlow(LanguageSelectionInfo));
